import { z } from "zod";

export const updateAttendanceLocalSchema = z.object({
    ativo: z.boolean().default(false),
    nome: z.string()
        .min(3, { message: "Mínimo de 3 caracteres" })
        .max(254, "Certifique-se de que este campo não tenha mais de 254 caracteres"),
    endereco: z.string()
        .min(5, { message: "Mínimo de 5 caracteres" })
        .max(255, "Certifique-se de que este campo não tenha mais de 255 caracteres"),
    bairro: z.string()
        .min(3, { message: "Mínimo de 3 caracteres" })
        .max(100, "Certifique-se de que este campo não tenha mais de 100 caracteres"),
    cep: z.string()
        .min(8, { message: "Mínimo de 8 caracteres para um cep válido" }),
    orgao_id: z.number({ message: "O campo é obrigatório" }),
    cidade: z.object({
        cidade: z.string(),
        estado: z.string(),
        slug: z.string(),
    }),
    complemento: z.string()
        .max(50, "Certifique-se de que este campo não tenha mais de 50 caracteres")
        .optional(),
    source: z.string()
        .min(3, { message: "Mínimo de 3 caracteres" }),
    slug_unidade: z.string().optional(),
    horario_unidade: z
        .object({
            dia_semana: z.array(z.string()).nullable().optional(),
        })
        .nullable()
        .optional(),
});

export type UpdateLocalSchemaData = z.infer<typeof updateAttendanceLocalSchema>;
